module.exports = __webpack_public_path__ + "img/02.163bb0bf.png";